export const PRODUCT_SKU_HEADER_TRIGGER = 'product-sku-header-trigger';
